import { AuthState } from '@okta/okta-auth-js';

import { FutureEntries } from '../../services/backend/FutureEntries';
import { useBaseApiClient } from '../useBaseApiClient';

export const useFutureEntries: () => FutureEntries<AuthState> = () => {
  return useBaseApiClient(FutureEntries);
};
